import { render, staticRenderFns } from "./MatchTennis.vue?vue&type=template&id=197ed740&scoped=true&"
import script from "./MatchTennis.vue?vue&type=script&lang=js&"
export * from "./MatchTennis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197ed740",
  null
  
)

export default component.exports